import { Component } from '@angular/core';
import {AuthService} from "../../../../Services/auth.service";

@Component({
  selector: 'app-create-asin-header',
  templateUrl: './create-asin-header.component.html',
  styleUrls: ['./create-asin-header.component.css']
})
export class CreateAsinHeaderComponent {
  name: string;
  constructor(private authService: AuthService) {}


  ngOnInit(): void {

    this.name = this.authService?.getDisplayName();

  }
}
